import AboutMe from "../AboutMe";
import HeroSection from "../HeroSection";
import Testimonials from "../Testimonials";
import ContactMe from "../ContactMe";
import Footer from "../Footer";
import MyServices from "../Services";
import Work from "../OurWork";

export default function Home() {
  return (
    <>
      <HeroSection />
      <MyServices />
      <AboutMe />
      <Testimonials />
      <ContactMe />
      <Work />
      <Footer />
    </>
  );
}
